import { useEffect } from 'react';

/**
 * Mantém a tela acesa enquanto `ativo` (Screen Wake Lock). No celular, tela
 * apagada corta o microfone (spec 024). O navegador solta a trava sozinho
 * quando a aba some; por isso quem chama põe a aba visível na condição — ao
 * voltar, `ativo` vira true de novo e a trava é pedida outra vez.
 */
export function useTelaAcesa(ativo: boolean): void {
  useEffect(() => {
    if (!ativo || typeof navigator === 'undefined' || !('wakeLock' in navigator)) return;
    let trava: WakeLockSentinel | null = null;
    let fim = false;
    navigator.wakeLock
      .request('screen')
      .then((t) => {
        if (fim) void t.release().catch(() => {});
        else trava = t;
      })
      .catch(() => {
        /* bateria fraca ou aba escondida: a tela apaga como sempre */
      });
    return () => {
      fim = true;
      void trava?.release().catch(() => {});
    };
  }, [ativo]);
}
